// ---------------------------------------------------------
// Make mobile menu slide in
// ---------------------------------------------------------

window.addEventListener("DOMContentLoaded", () => {
  const footerMenuIcon = document.querySelector(".footericon-menu");
  const slidingMenu = document.querySelector(".mobile-navbar-div");
  footerMenuIcon.addEventListener("click", () => {
    if (slidingMenu.classList.contains("hide-menu-right")) {
      slidingMenu.classList.remove("hide-menu-right");
    } else {
      slidingMenu.classList.add("hide-menu-right");
    }
  });

  // window.addEventListener("scroll", e => {
  //   const scrolled = window.pageYOffset;
  //   const headerBackground = document.querySelector("header.page-heading");
  //   if (headerBackground) {
  //     headerBackground.style.marginTop = -(scrolled * 0.2) + "px";
  //   } 
  // });
  //
  //

  window.addEventListener("scroll", () => {
    const progressBar = document.getElementById("myBar");
    let goodPercentage = 0;
    if (progressBar) {
      const scrolling = document.documentElement.scrollTop || document.body.scrollTop;
      const position = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const percentage = (scrolling / position) * 100;
      
      if (percentage <= 100) {
         goodPercentage = percentage;
      } else {
        goodPercentage = 100;
      }
      progressBar.style.width = goodPercentage + "%";
    }
  });
});
